var map = {
	"./DPINLogo.png": "4f41",
	"./KQLogo.png": "afbb",
	"./LZLogo.png": "1ee7",
	"./OHLogo.png": "a00d",
	"./SMFLogo.png": "cfb5",
	"./SQLogo.png": "c931",
	"./WBMLogo.png": "137b",
	"./WLPLogo.png": "bd70",
	"./XFZLogo.png": "535b",
	"./ZGWLogo.png": "9144"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "d7c3";